// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { ComponentTitleComponentFragmentDoc } from './componentTitleComponent.fragment.generated';
import { ComponentTitleAmpersandFragmentDoc } from './componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from './componentTitleText.fragment.generated';
export const ComponentTitleFragmentDoc = `
    fragment componentTitle on ComponentTitle {
  __typename
  alignment
  tag
  text
  texts {
    ...componentTitleComponent
  }
  color
  titleSize
  titleStyle
  titleWidth
}
    `;